import { observer } from 'mobx-react-lite';

import { Tooltip } from '@/components/ui';
import { cn } from '@/lib/utils';
import { userStore } from '@/stores/user.store';

type WatchedSignalProps = {
  watched: boolean;
  label: string;
  className?: string;
};

/** A small green ring on a card or routine that a card watcher is checking; only internal users see it.
 * Hollow, so it does not read as the filled dot that marks an unread routine run. */
export const WatchedSignal = observer(
  ({ watched, label, className }: WatchedSignalProps) => {
    if (!watched || !userStore.isInternalUser) return null;

    return (
      <Tooltip label={`${label} Internal only.`}>
        <span
          data-testid="watched-signal"
          aria-label={label}
          className={cn(
            'inline-flex size-2 shrink-0 rounded-full border-[1.5px] border-emerald-500',
            className
          )}
        />
      </Tooltip>
    );
  }
);
